export const HEY_TOKEN_ADDRESS = 'ST21FTC82CCKE0YH9SK5SJ1D4XEMRA069FKV0VJ8N.hey-token';
export const HEY_CONTRACT = 'ST21FTC82CCKE0YH9SK5SJ1D4XEMRA069FKV0VJ8N.hey-final';
export const MESSAGE_FUNCTION = 'send-message';
export const LIKE_FUNCTION = 'like-message';
export const REQUEST_FUNCTION = 'request-hey';
